var render = function render(){var _vm=this,_c=_vm._self._c;return _c('van-popup',{style:({ height: '80%' }),attrs:{"position":"bottom","closeable":"","close-icon-position":"top-right"},on:{"close":_vm.close},model:{value:(_vm.visible),callback:function ($$v) {_vm.visible=$$v},expression:"visible"}},[_c('div',{staticClass:"protocol-content",domProps:{"innerHTML":_vm._s(_vm.protocolHtml)}})])
}
var staticRenderFns = []

export { render, staticRenderFns }